/**
 * MessageComponent
 * @returns <Message />
 */
import Button from "./Button";
import { Link } from "react-router-dom";

const Message = ({ message }) => {
    return (
        <div className="message --with-margin-top">
            <div className="message__content">
                <h1>{message.title}</h1>
                <p>{message.text}</p>

                <Link to="/">
                    <Button {...message.btnConfig} />
                </Link>
            </div>

            <div className="message__image">
                {/* <img src={message.image} alt="" /> */}
                <img src={`${window._env_.STATIC_HOST}/static/website/images/photo-message.png`} alt="" />
            </div>
        </div>
    )
}

export default Message